import { useFeatureFlagStore } from "@/shared/store/featureFlag";

class LegalEntity {
  private readonly updatedTermsUrl = "/Electronic_Signatures_(ESIGN)_and_Online_Services_Agreement_November_2021.pdf";
  private readonly updatedHsaTermsUrl = "/Health_Savings_Account_Agreement_July_2026.pdf";

  private get isLegalNameChanged () {
    const featureFlagStore = useFeatureFlagStore();
    return featureFlagStore.flags.bend29017HsabBankDivision;
  }

  get divisionName () {
    return this.isLegalNameChanged ? "Santander" : "Webster";
  }

  getTermsUrl (existingTermsUrl: string) {
    return this.isLegalNameChanged ? this.updatedTermsUrl : existingTermsUrl;
  }

  getHsaTermsUrl (existingHsaTermsUrl: string) {
    return this.isLegalNameChanged ? this.updatedHsaTermsUrl : existingHsaTermsUrl;
  }

  substituteDivisionName (template: string) {
    return template.replace("{divisionName}", this.divisionName);
  }
}

export default (new LegalEntity());
